'use client';

import dynamic from 'next/dynamic';
import type { PhenomenonVenue } from '@/lib/phenomenon-pages';

const VenueMap = dynamic(() => import('./VenueMap'), {
  ssr: false,
  loading: () => (
    <div className="flex h-[300px] items-center justify-center content-card md:h-[400px]">
      <span className="text-sm text-text-secondary">Loading map...</span>
    </div>
  ),
});

export function VenueMapLazy({ venues, title }: { venues: PhenomenonVenue[]; title?: string }) {
  return <VenueMap venues={venues} title={title} />;
}
